import {connect} from "react-redux";
import EditTask from "./edit";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../service/fileUpload/action";
import {updateTask, getTaskById} from "../../../service/Task/action";

const mapStateToProps = (state) => ({
    taskDetailsById:state.Task.taskDetailsById,
    UpdateTaskDetails:state.Task.UpdateTask,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getTaskById,
            documentUploadUrlPublic,
            updateTask
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(EditTask);
